<template>
  <div v-if="contact.employer">
    <strong v-if="!hideLabel && (contact.employer.name || contact.employer.occupation)">Occupation/Employer</strong>
    <div>
    <span v-if="contact.employer.occupation">{{ contact.employer.occupation }}</span>
    <span v-if="contact.employer.occupation && contact.employer.name"> / </span>
    <span v-if="contact.employer.name">{{ contact.employer.name }}</span>
    </div>
    <span v-if="contact.employer.city">{{ contact.employer.city }}</span>
    <span v-if="contact.employer.state">, {{ contact.employer.state }}</span>
  </div>
</template>

<script>
export default {
  name: "RecipientInfo",
  props: {
    contId: {
      type: String,
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    contacts: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      contact: {}
    }
  },
  methods: {
    electionFilter(code) {
      return code === 'G' ? 'General Election' : 'Primary Election'
    },
  },
  created() {
    this.contact = this.contacts.find(c => c.contact_key === this.contId);
  },
}
</script>